import { render, staticRenderFns } from "./AssembleTheNumber.vue?vue&type=template&id=aa526398&lang=pug&"
import script from "./AssembleTheNumber.vue?vue&type=script&lang=js&"
export * from "./AssembleTheNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports